import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { UserRole } from '../types/user';

interface ProtectedRouteProps {
  element: React.ReactElement;
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, allowedRoles }) => {
  const { user, token, refreshToken } = useAuth();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  console.log('ProtectedRoute rendering, current state:', { user, token, allowedRoles });

  useEffect(() => {
    console.log('ProtectedRoute useEffect running');
    const checkAuthentication = async () => {
      console.log('Checking authentication');
      if (!user && token) {
        console.log('No user but token exists, attempting to refresh token');
        try {
          await refreshToken();
        } catch (error) {
          console.error('Token refresh failed:', error);
        }
      }
      setIsLoading(false);
    };

    checkAuthentication();
  }, [user, token, refreshToken]);

  if (isLoading) {
    console.log('ProtectedRoute is loading');
    return (
      <div className="flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <ProgressSpinner />
      </div>
    );
  }

  if (!user || !token) {
    console.log('No user or token found, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    console.log('User does not have required role, redirecting to unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }

  console.log('User authenticated and authorized, rendering protected component');
  return element;
};

export default ProtectedRoute;